import React, { useState, forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addAnswerItem } from '../../actions/answer-action';
import PropTypes from 'prop-types';
import * as service from '../../services/sTicket/ticket.service';

const AddAnswerForm = forwardRef(({ addAnswerItemConnect, ticket_id }, ref) => {

  
  const [formData, setFormData] = useState({
    id: -1,
    ticket_id: ticket_id,
    subject: '',    
  });
  

  // Define una referencia para el formulario
  const formRef = useRef(null);

  const handleChange = e => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { subject } = formData;
    if (subject === '') {
      alert("Subject can't be empty");
    } else {      
      service.addTicketAnswer(formData).then(async (response) => {
          const addedItem = response.data.data; 
          addAnswerItemConnect(addedItem);
          formReset();
      }).catch(() => {        
        formReset();    
      });
         
    }
  };



  const formReset = () => {
    setFormData({
      subject: '',      
    });
  };

  // Método para ejecutar la lógica de submit
  const handleFormSubmit = () => {
    if (formRef.current) {      
      handleSubmit({ preventDefault: () => {} });
    }
  };

  // Exponer el método handleFormSubmit mediante useImperativeHandle
  useImperativeHandle(ref, () => ({
    handleFormSubmit: handleFormSubmit
  }));


  const { subject } = formData;

  return (
    <div className="container-sm">
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="subject">Subject {ticket_id}</label>
            <textarea
              className="form-control"
              id="subject"
              rows="5"
              value={subject}
              onChange={handleChange}
            />
          </div>          
        </div>
      </form>
    </div>
  );
});

AddAnswerForm.propTypes = {
  addAnswerItemConnect: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  addAnswerItemConnect: bindActionCreators(addAnswerItem, dispatch),
});

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(AddAnswerForm);